import type { CSSProperties, JSX } from "react";
import { ICON_KEYS, iconRegistry } from "@/icons/icon-registry";
import { INK, TEXT_SECONDARY } from "../panel-tokens";
import { ACTUAL_COLOR, SCHEDULED_BORDER, SCHEDULED_BORDER_PX, SCHEDULED_FILL } from "./band-geometry";
import { formatDuration } from "./format-span";

const WaterdropIcon = iconRegistry[ICON_KEYS.WATERDROP];

const SCHEDULED_SWATCH = {
    backgroundColor: SCHEDULED_FILL,
    border: `${SCHEDULED_BORDER_PX}px solid ${SCHEDULED_BORDER}`,
};
const VALVE_OPEN_SWATCH = { backgroundColor: ACTUAL_COLOR };

function Item({ label, ms, swatchStyle }: { label: string; ms: number; swatchStyle: CSSProperties }) {
    return (
        <div className={"flex items-center gap-[5px]"}>
            <span aria-hidden className={"h-[10px] w-[12px] flex-none rounded-[2px]"} style={swatchStyle} />
            <span>
                {label} ·{" "}
                <span className={"font-medium tabular-nums"} style={{ color: INK }}>
                    {formatDuration(ms)}
                </span>
            </span>
        </div>
    );
}

export function BandLegend({ scheduledMs, actualMs }: { scheduledMs: number; actualMs: number }): JSX.Element {
    return (
        <div
            className={"flex flex-wrap items-center gap-x-[14px] gap-y-[4px] py-[8px] text-[12px] leading-[14px]"}
            style={{ color: TEXT_SECONDARY }}
        >
            <div className={"flex items-center gap-[4px] font-medium"}>
                <WaterdropIcon aria-hidden style={{ fontSize: 11 }} />
                <span>Irrigation</span>
            </div>
            {/* One flex item, so a narrow panel drops both totals to the next row together. */}
            <div className={"flex items-center gap-[12px]"}>
                <Item label={"Scheduled"} ms={scheduledMs} swatchStyle={SCHEDULED_SWATCH} />
                <Item label={"Valve open"} ms={actualMs} swatchStyle={VALVE_OPEN_SWATCH} />
            </div>
        </div>
    );
}
